import { render } from "./infoComponent.vue?vue&type=template&id=3d3b1626&scoped=true"
import script from "./infoComponent.vue?vue&type=script&lang=js"
export * from "./infoComponent.vue?vue&type=script&lang=js"

import "./infoComponent.vue?vue&type=style&index=0&id=3d3b1626&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3b1626"]])

export default __exports__